<div class="channel-badge">
  <span class="channel-pill">
    <i class="pi pi-share-alt"></i>
    {{ channelLabel }}
  </span>
  <button *appIfHasPermission="['omnichannel', 'assign-channel']" pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded p-button-sm channel-reassign" pTooltip="Reasignar canal" tooltipPosition="top" (click)="reassign.emit()"></button>
</div>
